module.exports = __webpack_public_path__ + "img/pass.a610354e.png";